import React from 'react';
import Modal from 'react-bootstrap/Modal';

import { Dropdown } from 'primereact/dropdown';

import './Style.css';
import { camposTabela } from "../../util/empreendimentos";
import tiposOperadores from '../../util/tipos_operadores';

class ModalRegras extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            no_rule: false,
            rule_name: '',
            field_to_validate: '',
            conditionals: [ this.getCondicaoInicial() ],
        };

        this.camposOptions = camposTabela;
        this.operadores = tiposOperadores;
    }

    componentDidUpdate = (prevProps) => {
        /*
         * Quando a modal é aberta, recebemos  as regras atuais do componente principal.
         */
        if (this.props.show && !prevProps.show) {
            const rules = this.props.regras || {};

            console.log(rules)

            /*
             * Se já existir uma regra configurada, carregamos a primeira.
             */
            if (Object.keys(rules).length > 0) {

                this.setState({
                    no_rule: rules.no_rule || false,
                    rule_name: rules.rule_name || '',
                    field_to_validate: rules.field_to_validate || '',
                    conditionals:
                        rules.conditionals &&
                        rules.conditionals.length > 0
                            ? rules.conditionals.map(
                                (conditional) => ({
                                    id: conditional.id,
                                    operator: conditional.operator || '',
                                    compare_with: conditional.compare_with || 'valor_fixo',
                                    fixed_value: conditional.fixed_value || '',
                                    field: conditional.field || '',
                                })
                            )
                            : [ this.getCondicaoInicial() ],
                });

                return;
            }

            /*
             * Caso não exista regra,
             * iniciamos a modal vazia.
             */
            this.resetarFormulario();
        }
    };

    /**
     * Cria uma condição vazia.
     */
    getCondicaoInicial = () => {
        return {
            id: Date.now() + Math.random(),
            operator: '',
            compare_with: 'valor_fixo',
            fixed_value: '',
            field: '',
        };
    };

    /**
     * Limpa a modal.
     */
    resetarFormulario = () => {
        this.setState({
            no_rule: false,
            rule_name: '',
            field_to_validate: '',
            conditionals: [ this.getCondicaoInicial() ],
        });
    };

    /**
     * "Sem regra".
     */
    handleSemRegraChange = (event) => {
        const semRegra = event.target.checked;

        this.setState({
            no_rule: semRegra,
        });

        /*
         * Quando marcar "Sem regra", avisamos imediatamente o componente pai.
         */
        if (semRegra && this.props.onRegraChange) {
            this.props.onRegraChange([]);
        }
    };

    /**
     * Nome da regra.
     */
    handleNomeChange = (event) => {
        this.setState({
            rule_name: event.target.value,
        });
    };

    /**
     * Campo a avaliar.
     */
    handleCampoAvaliarChange = (event) => {
        this.setState({
            field_to_validate: event.value,
        });
    };

    /**
     * Altera uma propriedade da condição.
     */
    handleCondicaoChange = (id, campo, valor) => {
        this.setState((prevState) => ({
            conditionals:
                prevState.conditionals.map(
                    (conditional) => {
                        if (conditional.id !== id) {
                            return conditional;
                        }

                        return {
                            ...conditional,
                            [campo]: valor,
                        };
                    }
                ),
        }));
    };

    /**
     * Altera o tipo de comparação.
     */
    handleCompararComChange = (id, valor) => {
        this.setState((prevState) => ({
            conditionals:
                prevState.conditionals.map(
                    (conditional) => {
                        if (conditional.id !== id) {
                            return conditional;
                        }

                        return {
                            ...conditional,
                            compare_with: valor,
                            fixed_value: '',
                            field: '',
                        };
                    }
                ),
        }));
    };

    /**
     * Verifica se uma condição está preenchida corretamente.
     */
    isCondicaoValida = (condicao) => {
        if (!condicao.operator) {
            return false;
        }

        if (condicao.compare_with === 'valor_fixo' && !condicao.fixed_value) {
            return false;
        }

        if (condicao.compare_with === 'outro_campo' && !condicao.field) {
            return false;
        }

        return true;
    };

    /**
     * Adiciona uma nova condição.
     *
     * A primeira linha permanece fixa.
     */
    handleAdicionarCondicao = () => {
        if (this.state.no_rule) {
            return;
        }

        const ultimaCondicao = this.state.conditionals[this.state.conditionals.length - 1];

        /*
         * Não deixa criar uma nova linha enquanto a atual estiver vazia.
         */
        if (!this.isCondicaoValida(ultimaCondicao)) {
            alert('Preencha todos os campos da condição antes de adicionar outra.');
            return;
        }

        this.setState((prevState) => ({
            conditionals: [
                ...prevState.conditionals,
                this.getCondicaoInicial(),
            ],
        }));
    };

    /**
     * Exclui uma condição.
     *
     * A primeira linha nunca é excluída.
     */
    handleExcluirCondicao = (id, index) => {
        if (index === 0) {
            return;
        }

        this.setState((prevState) => ({
            conditionals: prevState.conditionals.filter((conditional) => conditional.id !== id),
        }));
    };

    /**
     * Validação geral da modal.
     */
    validarFormulario = () => {
        /*
         * Sem regra é uma configuração válida.
         */
        if (this.state.no_rule) {
            return true;
        }

        if (!this.state.rule_name.trim()) {
            alert('Informe o nome da regra.');
            return false;
        }

        if (!this.state.field_to_validate) {
            alert('Selecione o campo a avaliar.');
            return false;
        }

        const condicaoInvalida =
            this.state.conditionals.some(
                (conditional) => !this.isCondicaoValida(conditional)
            );

        if (condicaoInvalida) {
            alert('Preencha todas as condições da regra antes de continuar.');
            return false;
        }

        return true;
    };

    /**
     * Salva a configuração da regra.
     */
    handleSalvar = () => {

        if (!this.validarFormulario()) {
            return;
        }

        /*
         * Monta o objeto da regra.
         *
         * Esse é praticamente o formato
         * que poderá ser enviado ao Laravel.
         */
        const regra = {
            id: this.props.regraAtual && this.props.regraAtual.id ? this.props.regraAtual.id : Date.now(),
            no_rule: this.state.no_rule ?? false,
            rule_name: this.state.rule_name,
            field_to_validate: this.state.field_to_validate,
            conditionals:
                this.state.conditionals.map(
                    (conditional) => ({
                        operator: conditional.operator,
                        compare_with: conditional.compare_with,
                        fixed_value: conditional.compare_with === 'valor_fixo' ? conditional.fixed_value : null,
                        field: conditional.compare_with === 'outro_campo' ? conditional.field : null,
                    })
                ),
        };

        /*
         * Envia a regra completa para
         * ConfigurarPesosAvaliacao.
         */
        if (this.props.onRegraChange) {
            this.props.onRegraChange( regra );
        }

        /*
         * Fecha a modal.
         */
        this.handleFechar();
    };

    /**
     * Fecha a modal.
     */
    handleFechar = () => {
        if (this.props.closeModal) {
            this.props.closeModal();
        }
    };

    render() {

        const {
            no_rule,
            rule_name,
            field_to_validate,
            conditionals,
        } = this.state;

        return (
            <div style={{ zIndex: '9999' }}>
                <Modal
                    show={this.props.show}
                    onHide={ this.handleFechar }
                    dialogClassName="modal-70w modal-regras"
                >
                    <Modal.Body>
                        <div className="container-fluid conteudo-modal">
                            <p className="title">Regra</p>

                            <label className="checkbox-info">
                                <input
                                    type="checkbox"
                                    name="no_rule"
                                    id="no_rule"
                                    checked={ no_rule }
                                    onChange={ this.handleSemRegraChange }
                                />
                                <span>Sem regra</span>
                            </label>

                            <div className="panel-body">
                                <div className="form-pesos">
                                    <div className="row">
                                        <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                                            <div className="form-group">
                                                <label>Nome (Na coluna gerada)</label>

                                                <input
                                                    type="text"
                                                    placeholder="Digite"
                                                    className="form-control campo"
                                                    value={ rule_name }
                                                    onChange={ this.handleNomeChange }
                                                    disabled={ no_rule }
                                                />
                                            </div>
                                        </div>

                                        <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                                            <div className="form-group">
                                                <label>Campo a avaliar</label>

                                                <Dropdown
                                                    value={ field_to_validate }
                                                    options={ this.camposOptions }
                                                    onChange={ this.handleCampoAvaliarChange }
                                                    placeholder="Selecione"
                                                    className="dropdown"
                                                    disabled={ no_rule }
                                                    showClear
                                                    filter
                                                    filterBy="label"
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    { conditionals.map((conditional, index) => (
                                            <div className="row" key={ conditional.id }>
                                                <div className="col-12 col-sm-12 col-md-3 col-lg-3">
                                                    <div className="form-group">
                                                        <label>Campo 1</label>
                                                        <Dropdown
                                                            value={ conditional.operator }
                                                            options={ this.operadores }
                                                            onChange={(
                                                                event
                                                            ) =>
                                                                this.handleCondicaoChange(
                                                                    conditional.id,
                                                                    'operator',
                                                                    event.value
                                                                )
                                                            }
                                                            placeholder="Selecione"
                                                            className="dropdown"
                                                            disabled={ no_rule }
                                                            showClear
                                                            filter
                                                            filterBy="label"
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                                                    <div className="form-group">
                                                        <label>Comparar com</label>
                                                        <div className="checkbox-group">
                                                            <label className="radio-info">
                                                                <input
                                                                    type="radio"
                                                                    name={`comparar-${conditional.id}`}
                                                                    value="valor_fixo"
                                                                    checked={
                                                                        conditional.compare_with ===
                                                                        'valor_fixo'
                                                                    }
                                                                    onChange={(
                                                                        event
                                                                    ) =>
                                                                        this.handleCompararComChange(
                                                                            conditional.id,
                                                                            event.target.value
                                                                        )
                                                                    }
                                                                    disabled={ no_rule }
                                                                />
                                                                <span>Valor Fixo</span>
                                                            </label>

                                                            <label className="radio-info">
                                                                <input
                                                                    type="radio"
                                                                    name={`comparar-${conditional.id}`}
                                                                    value="outro_campo"
                                                                    checked={
                                                                        conditional.compare_with ===
                                                                        'outro_campo'
                                                                    }
                                                                    onChange={(
                                                                        event
                                                                    ) =>
                                                                        this.handleCompararComChange(
                                                                            conditional.id,
                                                                            event.target.value
                                                                        )
                                                                    }
                                                                    disabled={ no_rule }
                                                                />
                                                                <span>Outro campo</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>

                                                { conditional.compare_with === 'valor_fixo' && (
                                                    <div className="col-12 col-sm-12 col-md-3 col-lg-3">
                                                        <div className="form-group">
                                                            <label>Campo 2</label>
                                                            <input
                                                                type="text"
                                                                placeholder="Digite"
                                                                className="form-control campo"
                                                                value={ conditional.fixed_value }
                                                                onChange={(
                                                                    event
                                                                ) =>
                                                                    this.handleCondicaoChange(
                                                                        conditional.id,
                                                                        'fixed_value',
                                                                        event.target.value
                                                                    )
                                                                }
                                                                disabled={ no_rule }
                                                            />
                                                        </div>
                                                    </div>
                                                )}

                                                { conditional.compare_with === 'outro_campo' && (
                                                    <div className="col-12 col-sm-12 col-md-3 col-lg-3">
                                                        <div className="form-group">
                                                            <label>Campo 2</label>
                                                            <Dropdown
                                                                value={ conditional.field }
                                                                options={
                                                                    this.camposOptions.filter(
                                                                        (item) => item.value !== conditional.campo1
                                                                    )
                                                                }
                                                                onChange={(
                                                                    event
                                                                ) =>
                                                                    this.handleCondicaoChange(
                                                                        conditional.id,
                                                                        'field',
                                                                        event.value
                                                                    )
                                                                }
                                                                placeholder="Selecione"
                                                                className="dropdown"
                                                                disabled={ no_rule }
                                                                showClear
                                                                filter
                                                                filterBy="label"
                                                            />
                                                        </div>
                                                    </div>
                                                )}

                                                <div className="col-12 col-sm-12 col-md-2 col-lg-2">
                                                    <div
                                                        className="form-group"
                                                        style={{
                                                            margin: "0px",
                                                            marginTop: "53px",
                                                            display: "flex",
                                                            gap: "5px",
                                                        }}
                                                    >
                                                        {index === 0 && (
                                                            /*
                                                             * O botão da modal continua normal.
                                                             *
                                                             * Ele NÃO recebe a classe active.
                                                             */
                                                            <button
                                                                type="button"
                                                                className="btn btn-adicionar-regra"
                                                                style={{ margin: "0px" }}
                                                                onClick={ this.handleAdicionarCondicao }
                                                                disabled={ no_rule }
                                                            >
                                                                Adicionar +
                                                            </button>
                                                        )}
                                                        {index > 0 && (
                                                            <button
                                                                type="button"
                                                                className="btn btn-excluir"
                                                                title="Excluir condição"
                                                                onClick={() =>
                                                                    this.handleExcluirCondicao(
                                                                        conditional.id,
                                                                        index
                                                                    )
                                                                }
                                                                disabled={ no_rule }
                                                            >
                                                                <i className="fa fa-trash"></i>
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    )}

                                    <div className="row modal-rodape">
                                        <div className="col-12 col-sm-12 col-md-9 col-lg-9">
                                            <p>O erro só será considerado se todas as condições aplicadas forem verdadeiras</p>
                                        </div>

                                        <div className="col-12 col-sm-12 col-md-3 col-lg-3">
                                            <button
                                                type="button"
                                                className="btn btn-block btn-submit-form"
                                                onClick={ this.handleSalvar }
                                            >
                                                SALVAR
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

export default ModalRegras;